import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./../Styles/designdetails.css";
import { API, UPLOADS } from "../../config/api";
import Adsense from "../../Admin/Pages/Adsense";

import VerticalAdsDis from "../../Admin/Pages/VerticleAdsDis";
import DesignDescription from "./DesignDescription";
import AdsSquare from "../../Admin/Pages/AdsSquare";

export default function DesigneDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const design = location.state;

  const [concepts, setConcepts] = useState([]);
  const [downloaded, setDownloaded] = useState({});
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(5);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [zoomData, setZoomData] = useState({
    show: false,
    x: 0,
    y: 0,
    xP: 0,
    yP: 0,
  });

  const handleDownloadClick = () => {
    // Check login
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    // If not logged in, open Navbar login popup
    if (!loginUser) {
      window.dispatchEvent(new Event("openLoginPopup"));
      return;
    }

    // User logged in -> continue download process
    const url = `${API.DOWNLOAD}&file=${encodeURIComponent(
      `FreeDesigns/${design.emb_file}`,
    )}`;

    setPendingDownloadUrl({
      url,
      code: design.design_code,
      id: design.id,
    });

    setAdTimer(5);
    setShowAdModal(true);
  };
  useEffect(() => {
    let interval;
    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);

  const imageUrl = design
    ? `${UPLOADS.DESIGN_IMAGE}/FreeDesigns/${design.jpeg_file}`
    : "";

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) setConcepts(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchConcepts();
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
    const y = Math.max(0, Math.min(e.clientY - rect.top, rect.height));

    setZoomData({
      show: true,
      x,
      y,
      sourceWidth: rect.width,
      sourceHeight: rect.height,
    });
  };
  if (!design)
    return <div className="loading-spinner">Loading design details...</div>;

  return (
    <div className="design-details-container">
      <button
        className="btn-back"
        onClick={() =>
          navigate("/designs", {
            state: { activeTab: design?.fromTab || "free" },
          })
        }
      >
        <i className="bi bi-arrow-left"></i> Back to Designs
      </button>

      <div className="row g-4">
        {/* LEFT COLUMN: IMAGE DISPLAY */}
        <div className="col-lg-4 pe-4">
          <div
            className="exact-zoom-source"
            onMouseMove={handleMouseMove}
            onMouseLeave={() =>
              setZoomData((previous) => ({ ...previous, show: false }))
            }
          >
            <img src={imageUrl} alt={design.design_code} draggable={false} />

            {zoomData.show && (
              <div
                className="exact-zoom-pointer"
                style={{
                  left: zoomData.x,
                  top: zoomData.y,
                }}
              />
            )}
          </div>
        </div>

        {/* RIGHT COLUMN: DETAILS OR ZOOM WINDOW */}
        <div className="col-lg-6 pe-4">
          {zoomData.show ? (
            <div className="exact-zoom-preview" aria-hidden="true">
              <div
                className="exact-zoom-copy"
                style={{
                  width: zoomData.sourceWidth,
                  height: zoomData.sourceHeight,
                  left: `calc(50% - ${zoomData.x * 3}px)`,
                  top: `calc(50% - ${zoomData.y * 3}px)`,
                  transform: "scale(3)",
                }}
              >
                <img src={imageUrl} alt="" draggable={false} />
              </div>
            </div>
          ) : (
            <div className="details-content">
              <span className="category-badge">{design.category}</span>
              <h1 className="design-code-title">
                Design Code: <span>{design.design_code}</span>
              </h1>
              <h3 className="price-tag">₹ FREE</h3>

              <div className="specs-grid">
                <div className="spec-row">
                  <strong>Stitches:</strong> <span>{design.stitch}</span>
                </div>
                <div className="spec-row">
                  <strong>Area:</strong> <span>{design.area}</span>
                </div>
                <div className="spec-row">
                  <strong>Colours:</strong> <span>{design.color}</span>
                </div>
                <div className="spec-row">
                  <strong>Format:</strong> <span>.EMB</span>
                </div>
                <div className="spec-row">
                  <strong>Concept:</strong>
                  <span>
                    {(Array.isArray(design.concepts_array)
                      ? design.concepts_array
                      : []
                    )
                      .map(
                        (id) =>
                          concepts.find((c) => String(c.id) === String(id))
                            ?.concept_name,
                      )
                      .filter(Boolean)
                      .join(", ") || "Not specified"}
                  </span>
                </div>
                <div className="spec-row full-width">
                  <strong>Details:</strong> <span>{design.details || ""}</span>
                </div>
              </div>

              {downloaded[design.id] ? (
                <button className="btn-action btn-downloaded" disabled>
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Downloaded
                </button>
              ) : (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadClick();
                  }}
                  className="btn-action btn-download"
                >
                  <i className="bi bi-download me-2"></i>
                  Download Free Design
                </button>
              )}
            </div>
          )}
        </div>

        {/* AD COLUMN */}
        <div className="col-lg-2">
          <div className="side-ad-container shadow-sm">
            <VerticalAdsDis />
          </div>
        </div>
      </div>
      <DesignDescription design={design} concepts={concepts} />
      {/* MODAL WINDOW */}
      {showAdModal && (
        <div className="dlm-overlay" onClick={() => setShowAdModal(false)}>
          <div className="dlm-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="dlm-content">
              <div className="dlm-header">
                <h2 className="dlm-title">Unlocking Your Design</h2>
                <p className="dlm-subtitle">
                  We provide 100% free designs thanks to our sponsors.
                </p>
              </div>

              <div className="dlm-ad-card">
                <div className="dlm-ad-badge">SPONSORED AD</div>
                <div className="dlm-ad-body">
                  <div className="dlm-ad-placeholder">
                    <AdsSquare />
                  </div>
                </div>
              </div>

              <div className="dlm-action-section">
                {adTimer > 0 ? (
                  <div className="dlm-timer-wrapper">
                    <span className="dlm-timer-text">
                      Preparing your file...
                    </span>
                    <div className="dlm-timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="dlm-ready-area">
                    <p className="dlm-ready-msg">✨ Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url || "#"}
                      className="dlm-btn-download"
                      onClick={(e) => {
                        e.preventDefault();
                        const url = pendingDownloadUrl?.url;
                        const code = pendingDownloadUrl?.code || "design";
                        const id = pendingDownloadUrl?.id;

                        if (!url) return;

                        let ext = "emb";
                        if (url.includes(".zip")) ext = "zip";
                        else if (url.includes(".rar")) ext = "rar";

                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `${code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        if (id) {
                          setDownloaded((prev) => ({
                            ...prev,
                            [id]: true,
                          }));
                        }

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              <button
                type="button"
                className="dlm-btn-dismiss"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
